import { render } from "./DescriptionComponent.vue?vue&type=template&id=73dcef82&scoped=true"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js"

import "./DescriptionComponent.vue?vue&type=style&index=0&id=73dcef82&lang=css"
import "./DescriptionComponent.vue?vue&type=style&index=1&id=73dcef82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73dcef82"]])

export default __exports__